(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tcmd-motion-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tcmd-motion-playback')) {
  customElements.define('tcmd-motion-playback', class extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('video')];
      this.visible = new Set();
      this.held = new Set();
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.shouldPlay = video => this.visible.has(video) && !document.hidden && !this.reducedMotion.matches && !this.held.has(video);
      this.sync = () => this.videos.forEach(video => {
        if (this.shouldPlay(video)) {
          video.muted = true;
          const request = video.play();
          request?.then(() => {
            if (!this.shouldPlay(video)) video.pause();
          }).catch(() => {});
        } else {
          video.pause();
        }
      });
      this.onPause = event => {
        if (this.shouldPlay(event.target)) this.held.add(event.target);
      };
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            this.visible.add(entry.target);
          } else {
            this.visible.delete(entry.target);
            this.held.delete(entry.target);
          }
        });
        this.sync();
      }, {threshold:[0,0.6,1]});
      this.videos.forEach(video => {
        video.muted = true;
        video.playsInline = true;
        video.addEventListener('pause', this.onPause);
        this.observer.observe(video);
      });
      document.addEventListener('visibilitychange', this.sync);
      this.reducedMotion.addEventListener('change', this.sync);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.sync);
      this.reducedMotion?.removeEventListener('change', this.sync);
      this.visible?.clear();
      this.videos?.forEach(video => {
        video.removeEventListener('pause', this.onPause);
        video.pause();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
